// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__chbV3","scrollbars":"styles_scrollbars__z5jSd","slideInSearchBar":"styles_slideInSearchBar__4xq2B"};